import { usePage, router } from '@inertiajs/react'
import { Radio, FileText, Gem, Inbox, TrendingUp } from 'lucide-react'
import { AppShell, type NavigationItem } from './shell'
import type { PageProps } from '../types/inertia'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { auth, url } = usePage<PageProps & { url: string }>().props
  const currentPath = typeof url === 'string' ? url : window.location.pathname

  // Determine active route - check if current path starts with the nav item's href
  const isActive = (href: string): boolean => {
    return currentPath.startsWith(href)
  }

  const navigationItems: NavigationItem[] = [
    {
      label: 'Reports',
      href: '/reports',
      icon: <FileText className="w-5 h-5" />,
      isActive: isActive('/reports'),
    },
    {
      label: 'Streams',
      href: '/streams',
      icon: <Radio className="w-5 h-5" />,
      isActive: isActive('/streams'),
    },
    {
      label: 'Items',
      href: '/items',
      icon: <Inbox className="w-5 h-5" />,
      isActive: isActive('/items'),
    },
    {
      label: 'Gems',
      href: '/gems',
      icon: <Gem className="w-5 h-5" />,
      isActive: isActive('/gems'),
    },
    {
      label: 'Trends',
      href: '/trends',
      icon: <TrendingUp className="w-5 h-5" />,
      isActive: isActive('/trends'),
    },
  ]

  const handleNavigate = (href: string) => {
    router.visit(href)
  }

  const handleUserSettings = () => {
    router.visit('/user_settings')
  }

  const handleSettings = () => {
    router.visit('/settings')
  }

  const handleGemTemplates = () => {
    router.visit('/gem_criteria_templates')
  }

  const handleLogout = () => {
    router.delete('/logout')
  }

  // Build user object from auth props
  const user = auth.user
    ? {
        name: auth.user.name,
        email: auth.user.email,
        avatarUrl: auth.user.avatarUrl,
        admin: auth.user.admin,
      }
    : undefined

  return (
    <AppShell
      navigationItems={navigationItems}
      user={user}
      onNavigate={handleNavigate}
      onUserSettings={handleUserSettings}
      onSettings={handleSettings}
      onGemTemplates={handleGemTemplates}
      onLogout={handleLogout}
    >
      {children}
    </AppShell>
  )
}
